import React from 'react';

export type FeatureFlagsContextType = FeatureFlag[]

interface FeatureFlag {
  id: string
  name: string
  isActive: boolean
}

export const FeatureFlagsContext = React.createContext([] as FeatureFlagsContextType);

const makeFeatureFlagProvider = <P extends FeatureFlagProviderProps>(
  Component?: React.ComponentType<P>,
  features: FeatureFlag[] = []
) => {
  const FeatureFlagProvider: React.FunctionComponent<P> = (props) => {
    const context = props.features ?? features;
    return (
      <FeatureFlagsContext.Provider value={context}>
        {Component !== undefined && <Component {...(props as P)} features={context} />}
        {Component === undefined && props.children}
      </FeatureFlagsContext.Provider>
    );
  };

  return FeatureFlagProvider;
};

export const withFeatureFlagProvider = <P extends FeatureFlagProviderProps>(
  Component: React.ComponentType<P>,
  features: FeatureFlag[] = []
) => makeFeatureFlagProvider(Component, features);

interface FeatureFlagProviderProps {
  features?: FeatureFlag[]
}

export const FeatureFlagProvider = makeFeatureFlagProvider();
